(function () {
	'use strict';

	function parseConfig(rawConfig) {
		if (!rawConfig) {
			return null;
		}

		try {
			return JSON.parse(rawConfig);
		} catch (error) {
			return null;
		}
	}

	function initWorldMap(wrap) {
		var config = parseConfig(wrap.getAttribute('data-wm-config'));
		if (!config || !config.uid || !config.groups) {
			return;
		}

		var svgEl = document.getElementById(config.uid + '-svg');
		var zoomG = document.getElementById(config.uid + '-g');
		var mrkG = document.getElementById(config.uid + '-markers');
		var tip = wrap.querySelector('.wm-tip');
		if (!svgEl || !zoomG || !mrkG || !tip) {
			return;
		}

		var geo = config.geo;
		var viewBoxWidth = config.vbW;
		var viewBoxHeight = config.vbH;

		function mercY(value) {
			var clamped = Math.max(-85, Math.min(85, value));
			var rad = clamped * Math.PI / 180;
			return Math.log(Math.tan(Math.PI / 4 + rad / 2));
		}

		function project(lng, lat) {
			var lngNorm = lng;
			while (lngNorm < geo.x1) {
				lngNorm += 360;
			}
			while (lngNorm > geo.x2) {
				lngNorm -= 360;
			}

			var x = (lngNorm - geo.x1) / (geo.x2 - geo.x1) * viewBoxWidth;
			var yTop = mercY(geo.y1);
			var yBottom = mercY(geo.y2);
			var y = (yTop - mercY(lat)) / (yTop - yBottom) * viewBoxHeight;

			return [x, y];
		}

		var scale = 1;
		var translateX = 0;
		var translateY = 0;
		var minScale = 1;
		var maxScale = 17;
		var dragging = false;
		var dragX = 0;
		var dragY = 0;
		var zoomAnimFrame = null;

		function applyMarkerScale(markerEl) {
			var x = parseFloat(markerEl.getAttribute('data-wm-x'));
			var y = parseFloat(markerEl.getAttribute('data-wm-y'));
			if (!Number.isFinite(x) || !Number.isFinite(y)) {
				return;
			}

			var invScale = 1 / scale;
			markerEl.setAttribute(
				'transform',
				'translate(' + x + ' ' + y + ') scale(' + invScale + ') translate(' + (-x) + ' ' + (-y) + ')'
			);
		}

		function syncMarkerScales() {
			Array.prototype.forEach.call(mrkG.children, function (markerEl) {
				applyMarkerScale(markerEl);
			});
		}

		function clampPan() {
			translateX = Math.min(0, Math.max(viewBoxWidth * (1 - scale), translateX));
			translateY = Math.min(0, Math.max(viewBoxHeight * (1 - scale), translateY));
		}

		function applyTransform() {
			zoomG.setAttribute('transform', 'translate(' + translateX + ' ' + translateY + ') scale(' + scale + ')');
			syncMarkerScales();
		}

		function zoomAt(px, py, factor) {
			var startScale = scale;
			var targetScale = Math.min(maxScale, Math.max(minScale, startScale * factor));

			if (Math.abs(targetScale - startScale) < 0.001) {
				return;
			}

			var startTranslateX = translateX;
			var startTranslateY = translateY;
			var targetTranslateX = px - (px - startTranslateX) * (targetScale / startScale);
			var targetTranslateY = py - (py - startTranslateY) * (targetScale / startScale);
			var duration = 180;
			var startTime = null;

			if (zoomAnimFrame !== null) {
				window.cancelAnimationFrame(zoomAnimFrame);
				zoomAnimFrame = null;
			}

			function easeOutCubic(t) {
				return 1 - Math.pow(1 - t, 3);
			}

			function animateZoom(timestamp) {
				if (startTime === null) {
					startTime = timestamp;
				}

				var progress = Math.min(1, (timestamp - startTime) / duration);
				var eased = easeOutCubic(progress);

				scale = startScale + (targetScale - startScale) * eased;
				translateX = startTranslateX + (targetTranslateX - startTranslateX) * eased;
				translateY = startTranslateY + (targetTranslateY - startTranslateY) * eased;
				clampPan();
				applyTransform();

				if (progress < 1) {
					zoomAnimFrame = window.requestAnimationFrame(animateZoom);
				} else {
					scale = targetScale;
					translateX = targetTranslateX;
					translateY = targetTranslateY;
					clampPan();
					applyTransform();
					zoomAnimFrame = null;
				}
			}

			zoomAnimFrame = window.requestAnimationFrame(animateZoom);
		}

		var zoomInButton = wrap.querySelector('.wm-zin');
		var zoomOutButton = wrap.querySelector('.wm-zout');
		if (zoomInButton) {
			zoomInButton.addEventListener('click', function () {
				zoomAt(viewBoxWidth / 2, viewBoxHeight / 2, 1.6);
			});
		}
		if (zoomOutButton) {
			zoomOutButton.addEventListener('click', function () {
				zoomAt(viewBoxWidth / 2, viewBoxHeight / 2, 1 / 1.6);
			});
		}

		svgEl.addEventListener('mousedown', function (event) {
			if (event.button !== 0) {
				return;
			}
			dragging = true;
			dragX = event.clientX;
			dragY = event.clientY;
			svgEl.style.cursor = 'grabbing';
		});

		window.addEventListener('mouseup', function () {
			if (!dragging) {
				return;
			}
			dragging = false;
			svgEl.style.cursor = 'grab';
		});

		window.addEventListener('mousemove', function (event) {
			if (!dragging) {
				return;
			}

			var rect = svgEl.getBoundingClientRect();
			translateX += (event.clientX - dragX) * (viewBoxWidth / rect.width);
			translateY += (event.clientY - dragY) * (viewBoxHeight / rect.height);
			dragX = event.clientX;
			dragY = event.clientY;
			clampPan();
			applyTransform();
		});

		svgEl.addEventListener('touchstart', function (event) {
			if (event.touches.length !== 1) {
				return;
			}
			dragging = true;
			dragX = event.touches[0].clientX;
			dragY = event.touches[0].clientY;
		}, { passive: true });

		svgEl.addEventListener('touchend', function () {
			dragging = false;
		});

		svgEl.addEventListener('touchmove', function (event) {
			if (!dragging || event.touches.length !== 1) {
				return;
			}

			var rect = svgEl.getBoundingClientRect();
			translateX += (event.touches[0].clientX - dragX) * (viewBoxWidth / rect.width);
			translateY += (event.touches[0].clientY - dragY) * (viewBoxHeight / rect.height);
			dragX = event.touches[0].clientX;
			dragY = event.touches[0].clientY;
			clampPan();
			applyTransform();
		}, { passive: true });

		function showTip(clientX, clientY, name, label, color) {
			tip.innerHTML = name + '<br><span style="color:' + color + ';font-size:11px;font-weight:500;">' + label + '</span>';
			tip.style.left = (clientX + 14) + 'px';
			tip.style.top = (clientY - 38) + 'px';
			tip.style.opacity = '1';
			tip.setAttribute('aria-hidden', 'false');
		}

		function hideTip() {
			tip.style.opacity = '0';
			tip.setAttribute('aria-hidden', 'true');
		}

		var active = {};
		var pending = {};
		Object.keys(config.groups).forEach(function (key) {
			active[key] = true;
			pending[key] = true;
		});

		function renderMarkers() {
			while (mrkG.firstChild) {
				mrkG.removeChild(mrkG.firstChild);
			}

			var svgNS = 'http://www.w3.org/2000/svg';

			Object.keys(config.groups).forEach(function (key) {
				if (!active[key]) {
					return;
				}

				var group = config.groups[key];
				group.locs.forEach(function (location) {
					var point = project(location.ln, location.la);
					var marker;

					if (group.shape === 'square') {
						var size = 9;
						marker = document.createElementNS(svgNS, 'rect');
						marker.setAttribute('x', point[0] - size / 2);
						marker.setAttribute('y', point[1] - size / 2);
						marker.setAttribute('width', size);
						marker.setAttribute('height', size);
						marker.setAttribute('rx', '1.5');
					} else {
						marker = document.createElementNS(svgNS, 'circle');
						marker.setAttribute('cx', point[0]);
						marker.setAttribute('cy', point[1]);
						marker.setAttribute('r', '5.5');
					}

					marker.setAttribute('fill', group.color);
					marker.setAttribute('stroke', '#fff');
					marker.setAttribute('stroke-width', '1.5');
					marker.setAttribute('vector-effect', 'non-scaling-stroke');
					marker.setAttribute('data-wm-x', point[0]);
					marker.setAttribute('data-wm-y', point[1]);
					applyMarkerScale(marker);
					marker.style.cursor = 'pointer';

					marker.addEventListener('mousemove', function (event) {
						showTip(event.clientX, event.clientY, location.n, group.label, group.color);
					});
					marker.addEventListener('mouseleave', hideTip);
					marker.addEventListener('touchstart', function (event) {
						event.stopPropagation();
						showTip(
							event.touches[0].clientX,
							event.touches[0].clientY,
							location.n,
							group.label,
							group.color
						);
						setTimeout(hideTip, 2200);
					}, { passive: true });

					mrkG.appendChild(marker);
				});
			});
		}

		var dropdowns = Array.prototype.slice.call(wrap.querySelectorAll('.wm-dropdown'));
		var checkboxes = Array.prototype.slice.call(wrap.querySelectorAll('.wm-filter-checkbox'));
		var applyButton = wrap.querySelector('.wm-apply');
		var clearButton = wrap.querySelector('.wm-clear');

		function getDropdownAllCheckbox(dropdown) {
			return dropdown.querySelector('.wm-filter-checkbox[data-all="true"]');
		}

		function getDropdownSpecificCheckboxes(dropdown) {
			return Array.prototype.slice.call(dropdown.querySelectorAll('.wm-filter-checkbox:not([data-all="true"])'));
		}

		function resetDropdownToAll(dropdown) {
			var allCheckbox = getDropdownAllCheckbox(dropdown);
			var specificCheckboxes = getDropdownSpecificCheckboxes(dropdown);

			if (allCheckbox) {
				allCheckbox.checked = true;
			}

			specificCheckboxes.forEach(function (checkbox) {
				checkbox.checked = false;
			});
		}

		function dropdownHasAllSelected(dropdown) {
			var allCheckbox = getDropdownAllCheckbox(dropdown);
			var specificCheckboxes = getDropdownSpecificCheckboxes(dropdown);

			return !!allCheckbox && allCheckbox.checked && specificCheckboxes.every(function (checkbox) {
				return !checkbox.checked;
			});
		}

		function closeDropdown(dropdown) {
			var toggle = dropdown.querySelector('.gardp-wm-filters__dropdown-toggle');
			var panel = dropdown.querySelector('.gardp-wm-filters__dropdown-panel');
			if (toggle) {
				toggle.setAttribute('aria-expanded', 'false');
			}
			if (panel) {
				panel.hidden = true;
			}
			dropdown.classList.remove('wm-dropdown--open');
		}

		function syncDropdownState() {
			dropdowns.forEach(function (dropdown) {
				dropdown.classList.toggle('gardp-wm-filters__dropdown--active', !dropdownHasAllSelected(dropdown));
			});
		}

		function fillPendingFromInputs() {
			Object.keys(pending).forEach(function (key) {
				pending[key] = false;
			});

			dropdowns.forEach(function (dropdown) {
				var allCheckbox = getDropdownAllCheckbox(dropdown);
				var specificCheckboxes = getDropdownSpecificCheckboxes(dropdown);

				if (allCheckbox && allCheckbox.checked) {
					specificCheckboxes.forEach(function (checkbox) {
						var key = checkbox.getAttribute('data-group');
						if (key && Object.prototype.hasOwnProperty.call(pending, key)) {
							pending[key] = true;
						}
					});
					return;
				}

				specificCheckboxes.forEach(function (checkbox) {
					var key = checkbox.getAttribute('data-group');
					if (key && Object.prototype.hasOwnProperty.call(pending, key)) {
						pending[key] = checkbox.checked;
					}
				});
			});
		}

		function hasPendingChanges() {
			return Object.keys(active).some(function (key) {
				return !!active[key] !== !!pending[key];
			});
		}

		function allBucketsAtDefault() {
			return dropdowns.every(function (dropdown) {
				return dropdownHasAllSelected(dropdown);
			});
		}

		function updateFilterActions() {
			if (applyButton) {
				applyButton.disabled = !hasPendingChanges();
			}
			if (clearButton) {
				clearButton.hidden = allBucketsAtDefault();
			}
		}

		function applyPendingFilters() {
			Object.keys(active).forEach(function (key) {
				active[key] = !!pending[key];
			});
			renderMarkers();
			syncDropdownState();
			updateFilterActions();
		}

		dropdowns.forEach(function (dropdown) {
			var toggle = dropdown.querySelector('.gardp-wm-filters__dropdown-toggle');
			var panel = dropdown.querySelector('.gardp-wm-filters__dropdown-panel');
			if (!toggle || !panel) {
				return;
			}

			toggle.addEventListener('click', function (event) {
				event.stopPropagation();

				var isOpen = toggle.getAttribute('aria-expanded') === 'true';
				dropdowns.forEach(function (otherDropdown) {
					if (otherDropdown !== dropdown) {
						closeDropdown(otherDropdown);
					}
				});

				toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
				panel.hidden = isOpen;
				dropdown.classList.toggle('wm-dropdown--open', !isOpen);
			});

			panel.addEventListener('click', function (event) {
				event.stopPropagation();
			});
		});

		document.addEventListener('click', function (event) {
			if (wrap.contains(event.target) && event.target.closest('.wm-dropdown')) {
				return;
			}
			dropdowns.forEach(closeDropdown);
		});

		checkboxes.forEach(function (checkbox) {
			checkbox.addEventListener('change', function () {
				var dropdown = checkbox.closest('.wm-dropdown');
				var isAllCheckbox = checkbox.getAttribute('data-all') === 'true';

				if (dropdown) {
					if (isAllCheckbox && checkbox.checked) {
						getDropdownSpecificCheckboxes(dropdown).forEach(function (item) {
							item.checked = false;
						});
					}

					if (!isAllCheckbox && checkbox.checked) {
						var allCheckbox = getDropdownAllCheckbox(dropdown);
						if (allCheckbox) {
							allCheckbox.checked = false;
						}
					}
				}

				fillPendingFromInputs();
				syncDropdownState();
				updateFilterActions();
			});
		});

		if (applyButton) {
			applyButton.addEventListener('click', function () {
				fillPendingFromInputs();
				applyPendingFilters();
			});
		}

		if (clearButton) {
			clearButton.addEventListener('click', function () {
				dropdowns.forEach(function (dropdown) {
					resetDropdownToAll(dropdown);
				});
				fillPendingFromInputs();
				applyPendingFilters();
			});
		}

		fillPendingFromInputs();
		syncDropdownState();
		updateFilterActions();
		renderMarkers();
	}

	function initAllMaps() {
		document.querySelectorAll('.wm-wrap[data-wm-config]').forEach(initWorldMap);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initAllMaps, { once: true });
	} else {
		initAllMaps();
	}
}());
